<template>
  <div>
    <!-- 充值记录弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="充值记录"
      :visible.sync="rechargeDialogVisible"
      :before-close="rechargeHandleClose"
      width="70%"
      center
    >
      <el-divider></el-divider>
      <el-table
        :data="rechargeData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column prop="date" label="编号" type="index"></el-table-column>
        <el-table-column prop="sms_type" label="收费类别">
          <template slot-scope="scope">
            <span v-if="scope.row.sms_type==1">订单短信</span>
            <span v-if="scope.row.sms_type==2">群发短信</span>
          </template>
        </el-table-column>
        <el-table-column prop="charge_type" label="计费类型">
          <template slot-scope="scope">
            <span v-if="scope.row.charge_type==1">计费</span>
            <span v-if="scope.row.charge_type==2">计时</span>
          </template>
        </el-table-column>
        <el-table-column prop="time_days" label="充值数量">
          <template slot-scope="scope">
            <span v-if="scope.row.charge_type==1">{{scope.row.Pay}}</span>
            <span v-if="scope.row.charge_type==2">{{scope.row.time_pay}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="充后余额">
          <template slot-scope="scope">
            <span v-if="scope.row.charge_type==1">{{scope.row.Balance}}</span>
            <span v-if="scope.row.charge_type==2">{{scope.row.time_pay}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="user_name" label="操作人"></el-table-column>
        <el-table-column prop="PayTime" label="充值时间"></el-table-column>
        <el-table-column prop="jfy_amount" label="金飞鹰收款金额"></el-table-column>
        <el-table-column prop="jfy_amount_time" label="收款时间"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page=""
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{rechargePar.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-dialog>
    <!-- 充值记录弹框开始 -->
  </div>
</template>

<script>
import { getScenicPayListPost } from "@/request/scenics.js";
export default {
  data() {
    return {
      rechargeDialogVisible: false,
      // 充值管理传参
      rechargePar: {
        scenic_id: "",
        page: 1,
        page_size: 8,
        token: ''
      },
      rechargeData: [],
      total: 1
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
  },
  methods: {
    // 备注内容
    remarkFn() {},
    // 充值弹框
    recharge(row) {
      // console.log(row)
      this.rechargePar = {
        scenic_id: row.ScenicID,
        page: 1,
        page_size: 8,
        token:this.Token
      };
      this.getData(this.rechargePar);
      this.rechargeDialogVisible = true;
    },
    getData(data) {
      getScenicPayListPost(data).then(res => {
        console.log(res);
        this.rechargeData = res.data.result.data;
        this.total = res.data.result.total;
      });
    },
    // 充值弹框X
    rechargeHandleClose() {
      this.rechargeDialogVisible = false;
    },
    // 分页
    handleCurrentChange(val) {
      console.log(val);
      this.rechargePar.page = val;
      this.getData(this.rechargePar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.remark {
  color: black;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
/deep/ .el-pagination{
  display: flex;
  flex-wrap: wrap;
}
/deep/.el-dialog{
  min-width: 400px;
}
</style>